<template>
  <div>
    <v-row no-gutters>
      <v-col cols="6" class="pr-2">
        <v-autocomplete
          v-model="type"
          outlined
          :items="items"
          item-text="name"
          item-value="id"
          :label="label"
          @change="typeChanged"
          dense
          hide-details="auto"
          :error-messages="errorMessages"
        />
      </v-col>
      <v-col cols="3" class="pl-2" v-if="type == 1">
        <v-text-field type="number" v-model="min" label="Min"></v-text-field>
      </v-col>
      <v-col cols="3" class="pl-2" v-if="type == 1">
        <v-text-field type="number" v-model="max" label="Max"></v-text-field>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import axiosClient from '@/api/httpClient'
export default {
  props: {
    bleNumber: Number,
    value: {
      type: Object | String,
      default() {
        return {
          type: 0
        }
      }
    },
    errorMessages: {
      type: Array,
      required: false
    }
  },
  data() {
    return {
      type: 0,
      min: null,
      max: null,
      bleSensorId: null,
      items: [{ id: null, name: '/' }],
      title: this.$attrs.label,
      bleSensorObject: {}
    }
  },
  computed: {
    label: function () {
      return 'BLE Sensor ' + this.bleNumber
    },
    errorMsg() {
      if (this.$attrs.errorMessages && this.$attrs.errorMessages.length) {
        return this.$attrs.errorMessages[0]
      }
      return null
    }
  },
  async created() {
    let response = await axiosClient.get('/lookup/bleSensorTypes')
    this.items = this.items.concat(response.data)
  },
  methods: {
    typeChanged() {
      if (this.type == 0) {
        this.value = null
        this.bleSensorObject = null
      } else {
        this.setInputObject()
      }
    },
    setInputObject() {
      let bleSensorInput = {}

      bleSensorInput.type = this.type
      bleSensorInput.min = this.min
      bleSensorInput.max = this.max

      if (this.type != null && this.type != 0) {
        this.bleSensorObject = bleSensorInput
      } else {
        this.bleSensorObject = null
      }
    }
  },
  watch: {
    min: {
      handler() {
        this.setInputObject()
      }
    },
    max: {
      handler() {
        this.setInputObject()
      }
    },
    value: {
      handler() {
        if (this.value != null && this.value.type != 0) {
          this.type = this.value.type
          this.min = this.value.min
          this.max = this.value.max
          this.bleSensorObject = this.value
        } else {
          this.value = null
          this.bleSensorObject = null
        }
      }
    },
    bleSensorObject: {
      handler() {
        this.$emit('input', this.bleSensorObject)
      }
    }
  }
}
</script>

<style lang="scss">
</style>